export const UserTypes = {
  updateInfo: "[User] UpdateInfo",
  clear: "[User] clear",
};
